<template>
  <div class="box">
    <div>
      <div class="row mt-3">
        <div class="col-12 pb-1 border-bottom">
          <h5 class="h5-sor"> {{this.common.name}}WiFi路由器 使用说明 </h5>
        </div>

      </div>
      <div class="col-12 w-100 mt-2">
        <div id="video1"
             style="height: 400px; background-color: rgb(0, 0, 0); overflow: hidden; position: relative;">
          <div class="ckplayerchzwmprsllmgtdwiwx"
               style="background-color: rgb(0, 0, 0); width: 100%; height: 100%;">
            <video-player id="chcpzjccspokrrnszz"  :options="video_help_router" ref="videoPlayer" class="video-player vjs-custom-skin"  webkit-playsinline="true" :playsinline="true" x5-playsinline="true" x5-video-orientation="landscape" style="object-fit:fill;"></video-player>
          </div>
        </div>
      </div>
      <ul class="list-unstyled">
        <li>
          <h4>准备工作</h4>
          <ul>
            <li>将路由器WAN口，与您的网络连接（建议使用默认DHCP自动分配IP地址模式）；</li>
            <li>将路由器接入电源启动；</li>
            <li>等待WiFi列表中出现 Openwet-2.4G_XXXX时，点击接入此WiFi节点（接入密码默认：12345678）；</li>
          </ul>
        </li>
        <li>
          <h4>配置VPN账号</h4>
          <ul>
            <li>在浏览器地址栏中输入192.168.101.1；</li>
            <li>在登录界面中，输入管理员用户名和密码（默认均为：admin）</li>
            <li>进入路由器后，点击顶部菜单MyVPN – myconfig选项；</li>
            <li>
              <h5>在页面中自上至下</h5>
              <ul>
                <li>
                  勾选开机自动运行；
                </li>
                <li>
                  在VPN服务器中，输入{{ this.common.linkStr }}
                </li>
                <li>
                  在用户名中，输入您的{{this.common.name}}账号；
                </li>
                <li>
                  在密码中，输入您的密码。完成后，点击底部“保存&amp;应用”按钮，略等1分钟，设备将开始初始化连接。
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          <h4>验证VPN是否已经连接</h4>
          <ul>
            <li>点击顶部菜单MyVPN – mystatus选项</li>
            <li>查看自己访问海外的ip地址，是否与本地ip地址不同，如不同，则说明已经成功连接；</li>
          </ul>
        </li>
        <li>
          <h4>其他配置</h4>
          <ul>
            <li>
              <h5>关于配置路由器WAN口上网的方法：</h5>
              <ul>
                <li>在路由器顶部菜单中，选择网络 – 接口选项；</li>
                <li>在接口总览页面中，找到WAN口图标，点击右侧“修改”；</li>
                <li>在接口-WAN配置页面中，点击协议下拉菜单，即可完成修改；</li>
              </ul>
            </li>
            <li>
              <h5>关于修改路由器WiFi用户名和接入密码:</h5>
              <ul>
                <li>在路由器顶部菜单中，选择网络 – 无线选项；</li>
                <li>在无线概况页面中，点击右侧“修改”按钮；</li>
                <li>在修改页面底部的接口配置选项，通过“基本设置”可以修改WiFi名称，在“无线安全；中，可以修改WiFi接入密码。</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>


      <br>
      <br>
      <br>
    </div>
    <footerPage></footerPage>
  </div>
</template>

<script>
import footerPage from "@/components/userInfo/footer";

export default {
  name: "useTutorial",
  components: {footerPage},

  data() {
    return {
      video_help_router: {
        autoplay: false,
        height: '400',
        preload: 'auto',
        controls: true,
        sources: [{
          src: this.common.downHost+'/video/help-router.mp4',
          type: 'video/mp4'
        }],
      }
    };
  },
  watch: {},
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
  },
  filters: {},
  methods: {

  },
}
</script>

<style scoped>
h4 {
  color: #2d8eff;
  margin-top: 2rem;
}

li {
  /*list-style: none;*/
}
</style>